"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarNetShopClient = void 0;
// https://vw-car-net.qs-shop-volkswagen-we.com/documentation/shop
class CarNetShopClient {
    constructor(authServiceWeConnect, stage) {
        this.authServiceWeConnect = authServiceWeConnect;
        this.stage = stage;
        this.resourceHostId = `myvw-car-net-shop-${stage}`;
    }
    // https://vw-car-net.qs-shop-volkswagen-we.com/documentation/shop/#/Checkout%20Data/getArticleInformation
    async getArticleInformation(vin, isWcar, shopCountry, shopLocale) {
        const url = `vw/de/v3/checkout/__userId__/article-information?gdc=${this.getGdcType(isWcar)}&vin=${vin}&shop-country=${shopCountry}&shop-locale=${shopLocale}`;
        const response = await this.authServiceWeConnect.get(this.resourceHostId, url);
        if (!response.ok) {
            throw new Error();
        }
        return await response.json();
    }
    getGdcType(isWcar) {
        return isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;
    }
}
exports.CarNetShopClient = CarNetShopClient;
//# sourceMappingURL=CarNetShopClient.js.map